@if (params?.showErrorMsg() && params?.getError(); as error) {
  <div class="center grid-ui-error-container">
    <grid-ui-error
      [errorCode]="error?.errorCode"
      [errorMessage]="error?.errorMessage"
      [errorPrimaryAction]="error?.errorPrimaryAction"
      [errorSecondaryAction]="error?.errorSecondaryAction"
      [showContact]="error?.showContact"
      [contactEmail]="error?.contactEmail"
      (primaryActionClick)="params?.loadData()"
      (secondaryActionClick)="reloadApp()"
    >
    </grid-ui-error>
  </div>
}

@if (params?.showLoadingMsg()) {
  <div class="justify-content-center align-items-center loading-container">
    <div>
      <div class="justify-content-center">
        <i class="fas fa-spinner fa-2x fa-spin loading-icon"></i>
      </div>
      <div class="justify-content-center mt-3">
        <p class="fst-italic">Loading, please wait...</p>
      </div>
    </div>
  </div>
}

@if (!params?.showLoadingMsg() && !params?.showErrorMsg()) {
  <div class="additional-subscribing">
    <div class="icon-container">
      @switch (params?.name) {
        @case ('index') {
          <grid-ui-icon class="icon line-chart-icon" name="line-chart"></grid-ui-icon>
        }
        @case ('profile') {
          <grid-ui-icon class="icon txt-icon" name="txt"></grid-ui-icon>
        }
        @case ('country') {
          <grid-ui-icon class="icon globe-icon" name="globe"></grid-ui-icon>
        }
        @case ('industry') {
          <grid-ui-icon class="icon globe-icon" name="industry"></grid-ui-icon>
        }
      }
    </div>
    @if (showAdditionalMsg()) {
      <div class="additional-msg">
        <h3>Interested in subscribing to additional {{ params?.namePlural }}?</h3>
        <div>
          <p>
            If you're interested in subscribing to additional {{ params?.namePlural }} please use the show restricted <br />
            toggle above to see the {{ params?.namePlural }} available or
            <a href="mailto: support@maplecroft.com <support@maplecroft.com>">contact us</a> for more information
          </p>
        </div>
      </div>
    }
    @if (showSubscribedToAllMsg()) {
      <div class="subscribed-to-all-msg">
        <h3>You are subscribed to all available risk {{ params?.namePlural }}</h3>
        <div>
          <p>
            If you have any questions about our risk {{ params?.name }} offering
            <a href="mailto: support@maplecroft.com <support@maplecroft.com>">contact us</a> for more information
          </p>
        </div>
      </div>
    }
    @if (showNoMatchMsg()) {
      <div class="no-match-msg">
        <h3>Interested in subscribing to additional {{ params?.namePlural }}?</h3>
        <div>
          <p>
            If you could not find the additional risk {{ params?.name }} you are looking for, <br />
            <a href="mailto: support@maplecroft.com <support@maplecroft.com>">contact us</a> for more information
          </p>
        </div>
      </div>
    }
    @if (showNoResultMsg()) {
      <div class="no-match-msg">
        <h3>{{ params?.noResultsMessage }}</h3>
        <div>
          <p>
            If you could not find the risk {{ params?.name }} you are looking for, <br />
            <a href="mailto: support@maplecroft.com <support@maplecroft.com>">contact us</a> for more information
          </p>
        </div>
      </div>
    }
  </div>
}
